import { RgDefaultCreate } from "./index15.js";
import { RG_TYPE } from "@project-rouge/rg-core";
const JoinWithCores = ({ groups, partialCore, firstCore, lastCore }) => {
	let children = [];
	if (firstCore) children.push(RgDefaultCreate(firstCore, RG_TYPE.Core));
	for (let i = 0; i < groups.length; i++) {
		children = children.concat(groups[i]);
		if (i === groups.length - 1) continue;
		children.push(RgDefaultCreate(partialCore, RG_TYPE.Core));
	}
	if (lastCore) children.push(RgDefaultCreate(lastCore, RG_TYPE.Core));
	return children;
};
export { JoinWithCores };

//# sourceMappingURL=index192.js.map